import { Settings2 } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'

export interface ColumnGroupConfig<TGroupId extends string = string> {
  id: TGroupId
  label: string
  description: string
  alwaysOn?: boolean
}

interface ColumnGroupsDropdownProps<TGroupId extends string> {
  groups: ColumnGroupConfig<TGroupId>[]
  visibleGroups: Set<TGroupId>
  onToggle: (groupId: TGroupId) => void
}

export function ColumnGroupsDropdown<TGroupId extends string>({
  groups,
  visibleGroups,
  onToggle,
}: ColumnGroupsDropdownProps<TGroupId>) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-1.5">
          <Settings2 className="h-3.5 w-3.5" />
          Columns
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-[200px]">
        <DropdownMenuLabel>Column Groups</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {groups.map((group) => (
          <DropdownMenuCheckboxItem
            key={group.id}
            checked={group.alwaysOn || visibleGroups.has(group.id)}
            disabled={group.alwaysOn}
            onCheckedChange={() => onToggle(group.id)}
          >
            <div>
              <div className="font-medium">{group.label}</div>
              <div className="text-xs text-muted-foreground">{group.description}</div>
            </div>
          </DropdownMenuCheckboxItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  )
}
